import { ApolloError } from "@apollo/client";
import { Alert, Paper } from "@mui/material";
import { Position } from "geojson";
import { useState } from "react";

import { GaiaMapMarker } from "~/modules/map/components/GaiaMapMarker";

interface PickupActionErrorProps {
    coordinates: Position;
    error: ApolloError;
}

const ERROR_WIDTH = 200;

export function PickupActionError({ coordinates, error }: PickupActionErrorProps) {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) return null;

    return (
        <GaiaMapMarker coordinates={coordinates} offset={[ERROR_WIDTH / -2, 0]}>
            <Paper>
                <Alert icon={false} sx={{ maxWidth: ERROR_WIDTH }} severity="error" onClose={() => setIsVisible(false)}>
                    {error.message}
                </Alert>
            </Paper>
        </GaiaMapMarker>
    );
}
